import React from 'react';
import { Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';

export function Error ({ children }) {
  return (
    <Alert variant="danger">
      <Alert.Heading>Ops! Ocorreu um erro!</Alert.Heading>
      <p>{children}</p>
    </Alert>
  );
}
Error.propTypes = {
  children: PropTypes.node.isRequired,
};
